import React from "react";
import "./VerticalBar.scss";

const VerticalBar = ({ number = "15", number1 = "30" }) => {
  return (
    <div className="vertical-bar">
      <div className="arch-vertical-bar">
        <div className="arrow2 arrow--top">▼</div>

        <div className="vertical-bar__number">{number}</div>
      </div>

      <div className="arch-vertical-bar"> 
        <div className="arrow2 arrow--bottom">▼</div>
        <div className="vertical-bar__number">{number1}</div>
      </div>
    </div>
  );
};

export default VerticalBar;
